export interface WorkAreaUpdate {
  WorkRegionCodes: Array<string>;
}
